import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export const carouselJsClass = 'js-carousel';
const paginationJsClass = carouselJsClass + '-pagination';
const buttonPreviousJsClass = carouselJsClass + '-button-previous';
const buttonNexJsClass = carouselJsClass + '-button-next';

const carouselElements = document.querySelectorAll('.' + carouselJsClass) as NodeListOf<HTMLElement>;

carouselElements.forEach((carouselElement) => {
    // Initialize Swiper
    initSwiper(carouselElement);
});

export function initSwiper (carouselElement: HTMLElement, initialSlide = 0): void {
    if (!carouselElement) {
        return;
    }

    // TODO: Accessibility

    // Get pagination and navigation buttons
    const paginationElement = carouselElement.querySelector('.' + paginationJsClass) as HTMLElement;
    const buttonPreviousElement = carouselElement.querySelector('.' + buttonPreviousJsClass) as HTMLElement;
    const buttonNextElement = carouselElement.querySelector('.' + buttonNexJsClass) as HTMLElement;

    // Initialize Swiper
    const swiper = new Swiper(carouselElement, {
        initialSlide,
        modules: [Navigation, Pagination],
        navigation: {
            disabledClass: 'c-button--disabled',
            nextEl: buttonNextElement,
            prevEl: buttonPreviousElement
        },
        pagination: {
            el: paginationElement,
            type: 'fraction'
        }
    });

    // When the active slide changes
    swiper.on('activeIndexChange', () => {
        // Update slides
        updateSlides(swiper);
    });

    // Wait for the swiper to load and update slides
    // (Not great but the swiper.slides is empty otherwise and swiper events don't seem to work)
    setTimeout(() => {
        updateSlides(swiper);
    }, 500);
}

function updateSlides (swiper: Swiper): void {
    if (!swiper) {
        return;
    }

    // For each slide
    swiper.slides.forEach((slide, index) => {
        // If the slide is active
        if (swiper.activeIndex === index) {
            // Remove aria-hidden
            slide.setAttribute('aria-hidden', 'false');
        } else {
            // Add aria-hidden
            slide.setAttribute('aria-hidden', 'true');
        }
    });
}